document.addEventListener('DOMContentLoaded', function () {
  const collapsibleSections = document.querySelectorAll('.section-collapsible-content');

  const svgIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" class="collapsible-svg-icon" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M16.707 4.71188L15.292 3.29688L13.878 4.71188L13.605 4.98588L8.70697 9.88288L2.12097 3.29688L0.70697 4.71187L8.70597 12.7109H8.70797L16.707 4.71188Z" fill="#E61E2A"/>
    </svg>
  `;

  collapsibleSections.forEach(section => {
    const collapsibleItems = section.querySelectorAll('.collapsible-item');
    const expandCollapseBtn = section.querySelector('.collapse-expand-all-btn');
    const expandCollapseText = expandCollapseBtn.querySelector('span');
    const expandCollapseIcon = expandCollapseBtn.querySelector('svg');

    let isAllExpanded = false;

    const updateExpandCollapseState = () => {
      const allExpanded = Array.from(collapsibleItems).every(item => item.getAttribute('aria-expanded') === 'true');
      const allCollapsed = Array.from(collapsibleItems).every(item => item.getAttribute('aria-expanded') === 'false');

      if (allExpanded) {
        isAllExpanded = true;
        expandCollapseText.textContent = 'Close all sections';
        expandCollapseIcon.style.transform = 'rotate(180deg)';
      } else if (allCollapsed) {
        isAllExpanded = false;
        expandCollapseText.textContent = 'Expand all sections';
        expandCollapseIcon.style.transform = 'rotate(0deg)';
      } else {
        // even one accordion open — still consider as expanded for toggle behavior
        isAllExpanded = true;
        expandCollapseText.textContent = 'Close all sections';
        expandCollapseIcon.style.transform = 'rotate(180deg)';
      }
    };

    // individual items accordion behaviour
    collapsibleItems.forEach((item, index) => {
      const header = item.querySelector('.collapsible-item__header');
      const content = item.querySelector('.collapsible-item__content');
      const iconContainer = item.querySelector('.collapsible-item__icon');

      iconContainer.innerHTML = svgIcon;
      const svgElement = iconContainer.querySelector('.collapsible-svg-icon');

      if (index === 0) {
        item.setAttribute('aria-expanded', 'true');
        content.hidden = false;
        svgElement.style.transform = 'rotate(180deg)';
      } else {
        item.setAttribute('aria-expanded', 'false');
        content.hidden = true;
        svgElement.style.transform = 'rotate(0deg)';
      }

      header.addEventListener('click', () => {
        const isExpanded = item.getAttribute('aria-expanded') === 'true';

        item.setAttribute('aria-expanded', !isExpanded);
        content.hidden = isExpanded;
        svgElement.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';

        // Close rest of the items
        collapsibleItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.setAttribute('aria-expanded', 'false');
            otherItem.querySelector('.collapsible-item__content').hidden = true;
            const otherIcon = otherItem.querySelector('.collapsible-svg-icon');
            if (otherIcon) {
              otherIcon.style.transform = 'rotate(0deg)';
            }
          }
        });

        updateExpandCollapseState();
      });
    });

    // Handle expand/collapse all button
    expandCollapseBtn.addEventListener('click', () => {
      isAllExpanded = !isAllExpanded;

      collapsibleItems.forEach(item => {
        const content = item.querySelector('.collapsible-item__content');
        const icon = item.querySelector('.collapsible-svg-icon');

        item.setAttribute('aria-expanded', isAllExpanded);
        content.hidden = !isAllExpanded;
        icon.style.transform = isAllExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
      });

      expandCollapseText.textContent = isAllExpanded ? 'Close all sections' : 'Expand all sections';
      expandCollapseIcon.style.transform = isAllExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
    });

    // Set initial button state
    updateExpandCollapseState();
  });
});
